import { analytics } from '@play-co/gcinstant';

import StateObserver from 'src/StateObserver';
import { createPersistentEmitter } from 'src/lib/Emitter';
import { RealtimeUserProperties } from 'src/lib/analytics/properties';
import { State } from 'src/state';
import { Pet } from 'src/replicant/buruburu/pet';
import { Inventory } from 'src/replicant/buruburu/inventory';
import { Visit } from 'src/replicant/visit';

export default function setupUserProps() {
  const selector = ({ user }: State): RealtimeUserProperties => ({
    $realtimeHasDisabledMessages: !user.settings.receiveMessages,
    $realtimeIsPurchaser: !!user.lifetimeValue,
    $realtimeLTV: user.lifetimeValue / 100,
    $realtimeLocale: user.settings.locale,
    $realtimePurchaseCount: StateObserver.replicant.getPurchaseHistory().length,
    $realtimeName: user.profile?.name,

    // Pet state, age, stage etc...
    ...Pet.getters(user).getAnalyticsUserProperties(
      StateObserver.now(),
      Visit.getters(user).isVisiting(),
    ),

    // stomach, love, dirtiness, stress etc...
    ...Pet.getters(user).getAnalyticsAttributeUserProperties(
      Math.floor(StateObserver.now() / 60_000) * 60_000,
    ),

    settings_bgm: user.settings.music,
    settings_sfx: user.settings.sound,
    settings_lang: user.settings.locale,
    settings_notif: user.settings.receiveMessages,

    // Currency report
    bPoints: Inventory.getters(user).getPoints(),
    freeGems: user.inventory.premium.free,
    paidGems: user.inventory.premium.paid,
    totalGems: Inventory.getters(user).getGems(),
    energy: Inventory.getters(user).getEnergy(StateObserver.now()),

    // Profile
    inGameProfileSet: !!user.publicProfile,
    publicProfileName: user.publicProfile?.name,

    // Level
    player_xp: user.level.xp,
    player_level: user.level.current,

    // Growth stage of the current pet
    stage: Pet.getters(user).getCurrentEvolution()?.stage ?? null,

    // Number of times the player has finished raising pets (= number of deaths or marriages)
    pets_raised: user.petRaised,

    // Highest pet age
    highest_age: user.highestPetAge,
  });

  createPersistentEmitter(selector).addListener((props) =>
    analytics.setUserProperties(props),
  );
}
